export default __webpack_public_path__ + "static/media/american-express.2f4a8594.jpg";